/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordSetChallengeOptions } from './PasswordSetChallengeOptions';
import {
    PasswordSetChallengeOptionsFromJSON,
    PasswordSetChallengeOptionsFromJSONTyped,
    PasswordSetChallengeOptionsToJSON,
} from './PasswordSetChallengeOptions';

/**
 * 
 * @export
 * @interface PasswordSetChallengeAllOf
 */
export interface PasswordSetChallengeAllOf {
    /**
     * 
     * @type {PasswordSetChallengeOptions}
     * @memberof PasswordSetChallengeAllOf
     */
    options: PasswordSetChallengeOptions;
}

/**
 * Check if a given object implements the PasswordSetChallengeAllOf interface.
 */
export function instanceOfPasswordSetChallengeAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function PasswordSetChallengeAllOfFromJSON(json: any): PasswordSetChallengeAllOf {
    return PasswordSetChallengeAllOfFromJSONTyped(json, false);
}

export function PasswordSetChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': PasswordSetChallengeOptionsFromJSON(json['options']),
    };
}

export function PasswordSetChallengeAllOfToJSON(value?: PasswordSetChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': PasswordSetChallengeOptionsToJSON(value.options),
    };
}

